module.exports = "/assets/0258051b4c39e6fd40e6065d9fdf345c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LZ.png
// module id = 1597
// module chunks = 0